import React, { createContext, FC } from 'react'

export interface JobDetailsProviderContextValue {
    EId?: string
    [key: string]: any
}

export const JobDetailsContext = createContext<JobDetailsProviderContextValue>({})

const { Provider, Consumer } = JobDetailsContext

export interface JobDetailsProviderProps {
    jobDetails: JobDetailsProviderContextValue
}
export const JobDetailsProvider: FC<JobDetailsProviderProps> = ({ jobDetails, children }) => (
    <Provider value={jobDetails}>
        {children}
    </Provider>
)

export default JobDetailsProvider
